import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Icon from "../Icon";

const SERVICE_LABELS = {
  events: "Events",
  lifestyle: "Lifestyle (Ambassadors & Marketing)",
  restaurants: "Restaurants",
  jobs: "Job Board",
  ugc: "UGC Creators",
};

export default function UpgradePopup({ open, onClose, serviceKey, featureName }) {
  const label = featureName || SERVICE_LABELS[serviceKey] || serviceKey || "this feature";

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 8 }}
            className="relative w-full max-w-md bg-gradient-to-b from-[#130D1F] to-[#0F0A1A] border border-[#2A2240] rounded-2xl p-6 shadow-2xl"
          >
            <div className="w-12 h-12 rounded-xl bg-[#8B3DFF]/15 border border-[#8B3DFF]/30 flex items-center justify-center mb-4">
              <Icon icon="heroicons:lock-closed" className="w-6 h-6 text-[#A855F7]" />
            </div>
            <h3 className="text-white text-lg font-semibold mb-2">Upgrade required</h3>
            <p className="text-[#8B85A0] text-sm leading-relaxed mb-6">
              Upgrade your plan to access <span className="text-white font-medium">{label}</span>.
              Choose the services you need and subscribe in a few clicks.
            </p>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-2.5 rounded-xl border border-[#2A2240] text-[#A89BB8] text-sm font-medium hover:bg-[#1E1830] transition-colors"
              >
                Close
              </button>
              <Link
                to="/partner-dashboard/subscription"
                onClick={onClose}
                className="flex-1 px-4 py-2.5 rounded-xl bg-[#8B3DFF] hover:bg-[#9B4DFF] text-white text-sm font-semibold text-center transition-colors shadow-[0_0_20px_rgba(139,61,255,0.25)]"
              >
                Go to Subscription
              </Link>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
